module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-24-224ea4e7181801afe568d0d9c2bf3966.svg";